// Device fingerprint utility
// NOTE: MAC addresses are not accessible via web browsers for security/privacy reasons
// This creates a fingerprint based on browser and device characteristics

export const generateDeviceFingerprint = () => {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('fingerprint', 2, 2);
    const canvasFingerprint = canvas.toDataURL();

    const fingerprint = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      colorDepth: window.screen.colorDepth,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      canvas: canvasFingerprint.slice(-50), // Last 50 chars of canvas fingerprint
      timestamp: new Date().getTime()
    };

    // Create a hash-like string from the fingerprint
    const fingerprintString = JSON.stringify(fingerprint);
    let hash = 0;
    for (let i = 0; i < fingerprintString.length; i++) {
      const char = fingerprintString.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    
    return Math.abs(hash).toString(36).toUpperCase();
  } catch (error) {
    console.error('Error generating device fingerprint:', error);
    // Fallback to simple timestamp-based ID
    return new Date().getTime().toString(36).toUpperCase();
  }
};

export const getDevicePlatform = () => {
  return navigator.platform || 'Unknown';
};

